const BASE = '';

function getToken() {
  return localStorage.getItem('token');
}

function getHeaders(auth) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

async function apiRequest(path, { method = 'GET', body, auth = true } = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: getHeaders(auth),
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (res.status === 204) return null;

  let data = null;
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    data = await res.json().catch(() => null);
  }

  if (!res.ok) {
    const message =
      data?.message || data?.error || `Request failed (${res.status} ${res.statusText})`;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export async function verifyAuth() {
  return apiRequest('/api/auth/verify', { auth: true });
}

export async function fetchMetrics() {
  try {
    return await apiRequest('/api/metrics');
  } catch (err) {
    return {
      totalRevenue: 0,
      activeCustomers: 0,
      pendingWithdrawals: 0,
      systemHealth: 100,
      revenueChart: { labels: [], data: [] },
    };
  }
}

export async function fetchIntegrations() {
  return apiRequest('/api/integrations');
}

export async function connectIntegration(id, config = {}) {
  return apiRequest(`/api/integrations/${encodeURIComponent(id)}/connect`, {
    method: 'POST',
    body: config,
  });
}

export async function disconnectIntegration(id) {
  return apiRequest(`/api/integrations/${encodeURIComponent(id)}/disconnect`, {
    method: 'POST',
  });
}

export async function testIntegration(id) {
  return apiRequest(`/api/integrations/${encodeURIComponent(id)}/test`, {
    method: 'POST',
  });
}

export async function syncIntegration(id) {
  return apiRequest(`/api/integrations/${encodeURIComponent(id)}/sync`, {
    method: 'POST',
  });
}
